// ポスター印刷の入稿欄: ファイル添付（20MBまで）・共有URL・注文後に送る のどれかを選ぶ。添付とURLは中身が必須。
// 使わない入力欄は disabled にして、注文情報（line item properties）に空の項目を送らない。
// 紙の横断幕・垂れ幕・カッティングシート制作では「文字の配置を依頼」も選べ、選ぶと隠してある選択肢「データ」を切り替える（価格 +1,650円）。
(() => {
  if (customElements.get('stckrs-poster-upload')) return;

  // 選択肢「データ」の切替中（フォームの variant id がまだ古い）のフォームID。切替が終わるまでカート追加を待たせる
  const switching = new Set();
  let resubmitForm = null;
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      switching.clear();
      if (resubmitForm) {
        const form = resubmitForm;
        resubmitForm = null;
        setTimeout(() => form.querySelector('[type="submit"]')?.click(), 0);
      }
    });
  }

  // 「文字の配置を依頼」の書体見本（stckrs-poster-upload.liquid の8書体と太さを合わせる）。
  // 和文は Google Fonts が文字ごとに分けて配信するので、表示に使う文字の分だけ読み込まれる
  const FONTS_URL =
    'https://fonts.googleapis.com/css2?family=BIZ+UDGothic:wght@700&family=Dela+Gothic+One&family=Klee+One:wght@600' +
    '&family=Noto+Sans+JP:wght@900&family=Noto+Serif+JP:wght@900&family=Shippori+Mincho:wght@800&family=Yuji+Syuku' +
    '&family=Zen+Maru+Gothic:wght@900&display=swap';
  const PREVIEW_SAMPLE = '第10回 定時総会\n株式会社○○';
  const loadFonts = () => {
    if (document.querySelector('link[data-stckrs-fonts]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONTS_URL;
    link.dataset.stckrsFonts = '';
    document.head.appendChild(link);
  };

  const formatMb = (bytes) => (Math.round((bytes / 1024 / 1024) * 10) / 10).toString();
  // 1MB未満はKBで表示する（0MBと出さない）
  const formatSize = (bytes) =>
    bytes < 1024 * 1024 ? `${Math.max(1, Math.round(bytes / 1024))}KB` : `${formatMb(bytes)}MB`;

  class StckrsPosterUpload extends HTMLElement {
    connectedCallback() {
      this.maxBytes = (Number(this.dataset.maxMb) || 20) * 1024 * 1024;
      this.fileInput = this.querySelector('[data-upload-file]');
      this.urlInput = this.querySelector('[data-upload-url]');
      this.laterInput = this.querySelector('[data-upload-later]');
      this.fileName = this.querySelector('[data-file-name]');
      this.fileNameProp = this.querySelector('[data-upload-filename]');
      this.message = this.querySelector('[data-upload-message]');
      this.layoutFields = this.querySelectorAll('[data-layout-field]');
      this.layoutText = this.querySelector('[data-layout-text]');
      this.layoutColor = this.querySelector('[data-layout-color]');
      this.preview = this.querySelector('[data-layout-preview]');

      this.querySelectorAll('[data-upload-mode]').forEach((radio) => {
        radio.addEventListener('change', () => {
          this.setMode(radio.value);
          this.syncDataOption();
        });
      });
      this.fileInput.addEventListener('change', () => this.checkFile());
      this.urlInput.addEventListener('input', () => this.clearMessage());
      this.layoutText?.addEventListener('input', () => {
        this.clearMessage();
        this.updatePreview();
      });
      this.layoutColor?.addEventListener('change', () => this.updatePreview());
      // カッティングシート制作は文字色＝「素材と色」で選んだシートの色（stckrs-cut-order.liquid）
      document.addEventListener('change', (event) => {
        if (event.target.matches?.(`[data-cut-color][form="${this.dataset.formId}"]`)) this.updatePreview();
      });
      this.querySelectorAll('[data-font-family]').forEach((radio) => {
        radio.addEventListener('change', () => this.updatePreview());
      });
      this.setMode(this.mode());
    }

    // 「文字の配置を依頼」かどうかに合わせて、選択肢「データ」のラジオボタン（Dawn の切替用・画面では隠している）を選ぶ
    syncDataOption() {
      if (!this.dataset.layoutValue) return;
      const want = this.mode() === 'layout' ? this.dataset.layoutValue : this.dataset.uploadValue;
      // Dawn は切替のたびに選択肢の HTML を入れ替えるので、毎回探し直す
      const radio = [...document.querySelectorAll(`input[form="${this.dataset.formId}"][data-option-name="データ"]`)].find(
        (input) => input.value === want
      );
      if (!radio || radio.checked) return;
      switching.add(this.dataset.formId);
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    isSwitching() {
      return switching.has(this.dataset.formId);
    }

    // 空の任意項目（配置のご要望）は注文情報に空欄で残さない。Dawn が FormData を作り終えたら元に戻す
    skipEmptyOptional() {
      if (this.mode() !== 'layout') return;
      this.querySelectorAll('[data-layout-optional]').forEach((field) => {
        if (field.value.trim()) return;
        field.disabled = true;
        setTimeout(() => {
          field.disabled = this.mode() !== 'layout';
        }, 0);
      });
    }

    mode() {
      return this.querySelector('[data-upload-mode]:checked')?.value || 'file';
    }

    setMode(mode) {
      this.querySelectorAll('[data-upload-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.uploadPanel !== mode;
      });
      this.fileInput.disabled = mode !== 'file';
      this.syncFileNameProp();
      this.urlInput.disabled = mode !== 'url';
      if (this.laterInput) this.laterInput.disabled = mode !== 'later';
      this.layoutFields.forEach((field) => {
        field.disabled = mode !== 'layout';
      });
      if (mode === 'layout') {
        loadFonts();
        this.updatePreview();
      }
      this.clearMessage();
    }

    // 入力した文字を、選んだ書体と文字色で見本に出す（未入力は例文を薄く）
    updatePreview() {
      if (!this.preview) return;
      const font = this.querySelector('[data-font-family]:checked');
      const text = this.layoutText.value.trim();
      this.preview.textContent = text || this.preview.dataset.sample || PREVIEW_SAMPLE;
      this.preview.classList.toggle('is-sample', !text);
      this.preview.style.fontFamily = font ? `'${font.dataset.fontFamily}', sans-serif` : '';
      this.preview.style.fontWeight = font?.dataset.fontWeight || '';
      if (this.layoutColor) {
        this.preview.style.color = this.layoutColor.selectedOptions[0]?.dataset.color || '';
      } else {
        this.previewSheetColor();
      }
    }

    // シートの色を見本の文字色にする。白など明るい色は暗い背景にのせ、すりガラス調（模様）はグレーで見せる
    previewSheetColor() {
      const radio = document.querySelector(`[data-cut-color][form="${this.dataset.formId}"]:checked`);
      const swatch = radio && document.querySelector(`label[for="${radio.id}"] .stckrs-swatch`);
      let color = swatch ? getComputedStyle(swatch).getPropertyValue('--stckrs-swatch').trim() : '';
      if (color.includes('gradient')) color = '#c9d0d5';
      this.preview.style.color = color;
      const probe = document.createElement('span');
      probe.style.color = color || '#111';
      document.body.appendChild(probe);
      const [r, g, b] = getComputedStyle(probe).color.match(/\d+/g).map(Number);
      probe.remove();
      const light = (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.75;
      this.preview.style.background = light ? '#3a3f44' : '';
    }

    showMessage(text) {
      this.message.textContent = text;
      this.classList.toggle('is-invalid', Boolean(text));
    }

    clearMessage() {
      this.showMessage('');
    }

    // 元のファイル名（添付モードでファイルがあるときだけ送る）
    syncFileNameProp() {
      const file = this.fileInput.files[0];
      this.fileNameProp.value = file ? file.name : '';
      this.fileNameProp.disabled = this.fileInput.disabled || !file;
    }

    // 選んだファイルを確認し、問題なければ名前と容量を表示する
    checkFile() {
      this.syncFileNameProp();
      const file = this.fileInput.files[0];
      if (!file) {
        this.fileName.textContent = 'ファイルを選択';
        return false;
      }
      this.fileName.textContent = `${file.name}（${formatSize(file.size)}）`;
      if (file.size > this.maxBytes) {
        this.showMessage(
          `ファイルが${formatMb(file.size)}MBあり、添付できる上限（20MB）を超えています。「共有URLで送る」をお選びください。`
        );
        return false;
      }
      this.clearMessage();
      return true;
    }

    checkUrl() {
      const value = this.urlInput.value.trim();
      if (!value) {
        this.showMessage('印刷データの共有URLを入力してください。');
        return false;
      }
      try {
        const url = new URL(value);
        if (url.protocol !== 'https:' && url.protocol !== 'http:') throw new Error('protocol');
      } catch {
        this.showMessage('URLの形式が正しくありません。https:// から始まる共有URLを貼り付けてください。');
        return false;
      }
      this.urlInput.value = value;
      this.clearMessage();
      return true;
    }

    // カート追加前の確認。不正なら false
    validate() {
      let ok;
      if (this.mode() === 'later') {
        // データは注文後に入稿ページから受け取る
        ok = true;
      } else if (this.mode() === 'layout') {
        ok = Boolean(this.layoutText.value.trim());
        this.showMessage(ok ? '' : '入れたい文字を入力してください。');
      } else if (this.mode() === 'url') {
        ok = this.checkUrl();
      } else if (!this.fileInput.files[0]) {
        this.showMessage('印刷データのファイルを選択してください（20MBを超える場合は「共有URLで送る」）。');
        ok = false;
      } else {
        ok = this.checkFile();
      }
      if (!ok) this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return ok;
    }

    // ファイルを送っている間、カートボタンの下に案内を出す（スピナーだけだとスマホ回線で止まって見える）
    // Dawn がボタンの loading を外したら消す
    showSending(form) {
      const file = !this.fileInput.disabled && this.fileInput.files[0];
      const button = form.querySelector('[type="submit"]');
      if (!file || !button) return;
      let note = form.querySelector('[data-upload-sending]');
      if (!note) {
        note = document.createElement('p');
        note.className = 'stckrs-upload__sending';
        note.setAttribute('aria-live', 'polite');
        note.dataset.uploadSending = '';
        button.after(note);
      }
      // Dawn の送信処理（loading の付与）はこのイベントのあとに走るので、次のタイミングで確かめる
      setTimeout(() => {
        if (!button.classList.contains('loading')) return;
        note.textContent = `印刷データ（${formatSize(file.size)}）を送信しています。通信環境によっては1分ほどかかります。画面を閉じずにお待ちください。`;
        const observer = new MutationObserver(() => {
          if (button.classList.contains('loading')) return;
          observer.disconnect();
          note.textContent = '';
        });
        observer.observe(button, { attributes: true, attributeFilter: ['class'] });
      }, 0);
    }
  }

  customElements.define('stckrs-poster-upload', StckrsPosterUpload);

  // ---- サイズ選択の下の送料・発送の目安 ----
  // 選んだバリエーションが送料込み（data-included の一覧）かどうかで送料の行を切り替える
  class StckrsPosterSummary extends HTMLElement {
    connectedCallback() {
      this.included = new Set((this.dataset.included || '').split(',').filter(Boolean));
      this.includedEl = this.querySelector('[data-summary-included]');
      this.paidEl = this.querySelector('[data-summary-paid]');
      // フォームの variant id は Dawn の切替処理のあとに変わるので、次のタイミングで読む
      this.onVariantChange = () => setTimeout(() => this.render(), 0);
      document.addEventListener('change', this.onVariantChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
      }
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantChange);
      this.unsubscribe?.();
    }

    render() {
      const id = document.getElementById(this.dataset.formId)?.querySelector('input[name="id"]')?.value;
      if (!id || !this.includedEl || !this.paidEl) return;
      const included = this.included.has(id);
      this.includedEl.hidden = !included;
      this.paidEl.hidden = included;
      // 自由サイズ（B3まで）なら「B3扱い：」を添える（選んだサイズはラジオボタンから読む）
      const size = document.querySelector(`input[type="radio"][form="${this.dataset.formId}"][value^="自由サイズ（"]:checked`);
      const code = size?.value.match(/自由サイズ（([AB]\d)まで）/)?.[1];
      this.querySelectorAll('[data-summary-class]').forEach((el) => {
        el.textContent = code ? `${code}扱い：` : '';
      });
    }
  }

  customElements.define('stckrs-poster-summary', StckrsPosterSummary);

  // ---- 特急（当日発送）と発送日の目安 ----
  // 受付は平日 cutoff 時まで（日本時間）。祝日・年末年始は data-holidays の一覧で判定する
  const WEEK = ['日', '月', '火', '水', '木', '金', '土'];
  const jstFormat = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23',
  });
  // 日本時間の「今日」（UTCの0時で表した日付）と時刻
  const jstNow = () => {
    const parts = Object.fromEntries(jstFormat.formatToParts(new Date()).map((p) => [p.type, p.value]));
    return { date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)), hour: +parts.hour };
  };
  const ymd = (date) => date.toISOString().slice(0, 10);
  const addDays = (date, days) => new Date(date.getTime() + days * 86400000);
  const label = (date) => `${date.getUTCMonth() + 1}/${date.getUTCDate()}（${WEEK[date.getUTCDay()]}）`;
  const yen = (cents) => `¥${Math.round(cents / 100).toLocaleString('ja-JP')}`;

  class StckrsPosterExpress extends HTMLElement {
    connectedCallback() {
      this.holidays = new Set((this.dataset.holidays || '').split(',').filter(Boolean));
      this.cutoff = Number(this.dataset.cutoffHour) || 12;
      const mapEl = this.querySelector('[data-express-map]');
      this.feeMap = mapEl ? JSON.parse(mapEl.textContent) : null;
      this.check = this.querySelector('[data-express-check]');
      this.priceEl = this.querySelector('[data-express-price]');
      this.noteEl = this.querySelector('[data-express-note]');
      this.etaEl = this.querySelector('[data-express-eta]');
      // Dawn が購入エリアを再描画しても選択を保つ
      const stateKey = `stckrsExpress_${this.dataset.formId}`;
      if (this.check) {
        this.check.checked = Boolean(window[stateKey]);
        this.check.addEventListener('change', () => {
          window[stateKey] = this.check.checked;
          this.render();
        });
      }
      this.onVariantChange = () => setTimeout(() => this.render(), 0);
      document.addEventListener('change', this.onVariantChange);
      this.render();
      this.timer = setInterval(() => this.render(), 60000);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantChange);
      clearInterval(this.timer);
    }

    form() {
      return document.getElementById(this.dataset.formId);
    }

    variantId() {
      return this.form()?.querySelector('input[name="id"]')?.value;
    }

    fee() {
      return this.feeMap?.[this.variantId()] || null;
    }

    // 入稿欄で「注文後に送る」を選んでいるか（その場合は特急を受けない）
    isDataLater() {
      return document.querySelector(`stckrs-poster-upload[data-form-id="${this.dataset.formId}"]`)?.mode() === 'later';
    }

    isBusinessDay(date) {
      const day = date.getUTCDay();
      return day !== 0 && day !== 6 && !this.holidays.has(ymd(date));
    }

    nextBusinessDay(date) {
      let d = addDays(date, 1);
      while (!this.isBusinessDay(d)) d = addDays(d, 1);
      return d;
    }

    // 今この時点で特急を受け付けられるか
    isOpenNow() {
      const now = jstNow();
      return this.isBusinessDay(now.date) && now.hour < this.cutoff;
    }

    wantsExpress() {
      return Boolean(this.check?.checked && this.fee());
    }

    render() {
      const now = jstNow();
      const open = this.isOpenNow();
      const fee = this.fee();
      const later = this.isDataLater();
      if (this.check) {
        this.check.disabled = !open || !fee || later;
        if (this.check.disabled) {
          this.check.checked = false;
          window[`stckrsExpress_${this.dataset.formId}`] = false;
        }
        this.priceEl.textContent = fee ? `+${yen(fee.price)}` : '';
        if (later) {
          this.noteEl.textContent = '「注文後に送る」を選んだ場合はご利用いただけません';
        } else if (open) {
          this.noteEl.textContent = `本日 ${label(now.date)} ${this.cutoff}:00までのご注文で当日発送`;
        } else {
          const next = this.nextBusinessDay(now.date);
          this.noteEl.textContent = `受付時間外です。次の受付: ${label(next)} ${this.cutoff}:00まで（平日のみ）`;
        }
      }
      // 通常はデータ確認後2〜3営業日（今日を含めず数える）
      const day2 = this.nextBusinessDay(this.nextBusinessDay(now.date));
      const day3 = this.nextBusinessDay(day2);
      if (later) {
        this.etaEl.textContent = '発送予定: データが届いてから2〜3営業日（データ確認後）';
      } else {
        this.etaEl.textContent = this.wantsExpress()
          ? `発送予定: 本日 ${label(now.date)}（データ確認後）`
          : `発送予定: ${label(day2)}〜${label(day3)}ごろ（データ確認後）`;
      }
    }

    // 特急料金をカートへ入れる。成功なら true
    async addFee() {
      const fee = this.fee();
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: fee.id, quantity: 1, properties: { 対象: `${this.dataset.productName} ${fee.size}` } }],
          }),
        });
        if (!res.ok) throw new Error(String(res.status));
        return true;
      } catch {
        this.etaEl.textContent = '特急料金をカートに入れられませんでした。時間をおいて再度お試しください。';
        return false;
      }
    }
  }

  customElements.define('stckrs-poster-express', StckrsPosterExpress);

  // カートに入れる前に入稿を必須にし、特急なら特急料金も入れる（Dawn の product-form より先に捕まえる）
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      // form.id は name="id"（バリエーションID）の入力欄に隠れるので属性から読む
      const formId = form.getAttribute('id');
      if (!formId) return;
      // 自由サイズ: 寸法の確認と値の切替を先に済ませる（切替前のバリエーションで特急料金を選ばないように）。
      // 切替中なら stckrs-free-size.js が送信を止め、切替後に送り直す
      const free = [...document.querySelectorAll('[data-free-prop]')]
        .find((prop) => prop.getAttribute('form') === formId)
        ?.closest('stckrs-free-size');
      if (free?.validate) {
        if (!free.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (free.isPending()) return;
      }
      const upload = [...document.querySelectorAll('[data-upload-file]')]
        .find((input) => input.getAttribute('form') === formId)
        ?.closest('stckrs-poster-upload');
      if (upload && !upload.validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      // 「データ」の切替中は、切替が終わってから送り直す（古いバリエーション＝違う価格でカートに入れない）
      if (upload?.isSwitching()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        resubmitForm = form;
        return;
      }
      upload?.skipEmptyOptional();

      // 特急: 先に特急料金をカートへ入れてから、ポスター本体の送信をやり直す
      // （Dawn のカート表示が特急料金を含んだ状態で更新されるように）
      const express = document.querySelector(`stckrs-poster-express[data-form-id="${formId}"]`);
      if (!express || !express.wantsExpress()) {
        upload?.showSending(form);
        return;
      }
      if (form.dataset.expressAdded === '1') {
        delete form.dataset.expressAdded;
        upload?.showSending(form);
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!express.isOpenNow()) {
        // ページを開いたまま締め切りを過ぎた場合
        express.render();
        return;
      }
      const button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-disabled', 'true');
      express.addFee().then((ok) => {
        if (button) button.removeAttribute('aria-disabled');
        if (!ok) return;
        form.dataset.expressAdded = '1';
        form.requestSubmit();
      });
    },
    true
  );
})();
